module.exports = __webpack_public_path__ + "static/media/P17.b907eefb.png";